// extracted by mini-css-extract-plugin
export var createdDate = "_np-1";
export var divider = "_np-2";
export var headerDivider = "_np-3";
export var messagesCard = "_np-0";
export var messagesContainer = "_np-7";
export var messagesContainerWrapper = "_np-4";
export var pointerCapturingButtonBoxes = "_np-a";
export var showLeftPanelButton = "_np-9";
export var showMoreButton = "_np-c";
export var showMoreButtonContainer = "_np-b";
export var summaryTitle = "_np-6";
export var systemMessageCardWrapper = "_np-d";
export var topButtons = "_np-8";
export var withPadding = "_np-5";